import { useContext } from 'react';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import CowcamoTextLink from '@/components/CowcamoTextLink';
import { getSiteOrigin } from '@/utils/site-origin';

import styles from './index.module.scss';

/**
 * A link back to the cowcamo website top, used to recover from dead-end error pages: an
 * `app_id`-less or expired session can't sign in on this auth host, so the way out is the cowcamo
 * site, where a normal login can be started. Renders nothing when the site origin is unknown.
 *
 * Kept as a cowcamo-owned component (with the label hardcoded — cowcamo is Japanese-only) so the
 * recovery lives outside upstream files: it keeps this cowcamo-specific string out of the shared
 * phrases and shrinks the touch on Logto's `ErrorPage` to a single line, avoiding merge churn on
 * upstream syncs.
 */
const CowcamoSiteLink = () => {
  const { experienceSettings } = useContext(PageContext);
  const siteOrigin = getSiteOrigin(experienceSettings);

  if (!siteOrigin) {
    return null;
  }

  return (
    <CowcamoTextLink className={styles.link} href={siteOrigin}>
      サイトトップへ戻る
    </CowcamoTextLink>
  );
};

export default CowcamoSiteLink;
